var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"brief":_vm.brief,"orders":_vm.orders,"isLoading":_vm.isLoading,"currentPage":_vm.currentPage,"numberOfPages":_vm.numberOfPages,"loadOrdersPage":_vm.loadOrdersPage})],2)}
var staticRenderFns = []

export { render, staticRenderFns }